export const THEME_STORAGE_KEY = "wa-ui-theme";

export const THEMES = {
  forest: {
    id: "forest",
    label: "Green",
    primary: "#0B939A",
    page: "#f3f9fa",
    border: "#bbe1e3",
  },
  ocean: {
    id: "ocean",
    label: "Ocean",
    primary: "#044463",
    page: "#eef5f8",
    border: "#c5d7e0",
  },
};

export const DEFAULT_THEME_ID = "ocean";

export function isThemeId(value) {
  return Boolean(value && THEMES[value]);
}

export function readStoredThemeId() {
  try {
    const value = window.localStorage.getItem(THEME_STORAGE_KEY);
    if (isThemeId(value)) return value;
  } catch {
    /* ignore */
  }
  return DEFAULT_THEME_ID;
}

export function persistThemeId(themeId) {
  try {
    window.localStorage.setItem(THEME_STORAGE_KEY, themeId);
  } catch {
    /* ignore */
  }
}

export function applyDocumentTheme(themeId) {
  const theme = THEMES[themeId] || THEMES[DEFAULT_THEME_ID];
  const root = document.documentElement;
  root.setAttribute("data-theme", theme.id);
  root.style.setProperty("--primary-color", theme.primary);
  root.style.setProperty("--sidebar-bg", theme.primary);
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute("content", theme.primary);
}
